import React, { useState } from 'react'
import { Text, Input, Button } from '@components/UI'

const reviewPrompt = {
  CLASSROOM:
    'What would you like to see changed or added to the GoPeer Classroom?',
  SESSION: 'Could you tell us how you liked this lesson with'
}

const reviewButton = {
  CLASSROOM: 'Share Feedback',
  SESSION: 'Review'
}

const closeButton = {
  CLASSROOM: 'Skip',
  SESSION: 'Back to the Dashboard'
}

const Review = ({ small, type, isTutor, person, onSubmit, onExit, onBook }) => {
  const [value, setValue] = useState('')
  const [error, setError] = useState(false)

  const getReviewPrompt = () => {
    return (
      <>
        {reviewPrompt[type]}
        {type === 'SESSION' && (
          <font
            className='semibold'
            style={{ color: 'rgba(255, 255, 255, .75)' }}
          >
            {' '}
            {person.name}?
          </font>
        )}
      </>
    )
  }

  return (
    <div className='gp-feedback-review'>
      {!small && (
        <Text
          className='text-e'
          style={{
            color: 'rgba(255, 255, 255, .45)'
          }}
        >
          {getReviewPrompt()}
        </Text>
      )}

      <Input
        className={error ? 'with-error' : ''}
        type='textarea'
        maxLength={150}
        events={{
          onChange: (value) => setValue(value),
          onFocus: () => setError(false)
        }}
        {...(small
          ? {
              placeholder: `Could you tell us how you liked this lesson with ${person.name}?`
            }
          : {})}
      />
      <div
        className={`actions-container actions-container--${
          isTutor && !small ? 'vertical' : 'horizontal'
        }`}
      >
        <Button
          className='medium'
          theme='c interactive'
          inverted
          group={small ? 'a3' : 'a4'}
          icon={{
            name: 'star',
            value: reviewButton[type],
            group: small ? 'a' : 'a2'
          }}
          events={{
            onClick: () => {
              if (!value) setError(true)
              else onSubmit(value)
            }
          }}
        />
        {isTutor && !small && (
          <Button
            className='back medium'
            theme='f interactive'
            icon={{
              name: 'plus',
              value: 'Book Next Session',
              group: 'a2'
            }}
            group='a4'
            events={{
              onClick: onBook
            }}
          />
        )}
        <Button
          className='back medium'
          theme={`${small ? 'j inverted' : 'f'} interactive`}
          icon={{
            name: small ? 'close' : 'ok',
            value: small ? 'Close' : closeButton[type],
            group: small ? 'a' : 'a2'
          }}
          group={small ? 'a3' : 'a4'}
          events={{
            onClick: onExit
          }}
        />
      </div>
    </div>
  )
}

export default Review
